// A real <form noValidate> (FR-047): Enter in any field submits once, through the browser's implicit
// submission; the default navigation is prevented. The visually hidden submit button is what makes
// implicit submission work in a form with several fields (React Native Web buttons are not <button>).
import type { CSSProperties } from "react";

import type { FormProps } from "./Form";

const visuallyHidden: CSSProperties = {
  position: "absolute",
  width: 1,
  height: 1,
  overflow: "hidden",
  clipPath: "inset(50%)",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  margin: -1,
};

export type { FormProps };

export function Form({
  onSubmit,
  accessibilityLabel,
  children,
  testID,
}: FormProps) {
  return (
    <form
      noValidate
      aria-label={accessibilityLabel}
      data-testid={testID}
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      {children}
      <button
        type="submit"
        tabIndex={-1}
        aria-hidden="true"
        style={visuallyHidden}
      />
    </form>
  );
}
